import "./index.scss";

import { Box, Stack } from "@mui/material";
import { ReactComponent as IconAttentionOrange } from "assets/images/icons/attention-orange.svg";
import { ReactComponent as IconUserOrangeCircle } from "assets/images/icons/user-orange-circle.svg";
import Tooltip from "components/Tooltip";
import { GENERIC_MEMBER_STATUS_OPTIONS } from "constants/index";
import { TMember } from "models/member";

const TCAUserSummary = (props: {
  member: TMember;
  appointment: string;
  isSMSubscale?: boolean;
  isSSSubscale?: boolean;
  isATDSubscale?: boolean;
}) => {
  const { member, appointment, isSMSubscale, isSSSubscale, isATDSubscale } = props;

  return (
    <Stack className="tcaUserSummary" direction={"row"} mb={1.875}>
      <Stack direction={"row"} alignItems="center" gap={1}>
        <IconUserOrangeCircle />
        {`${member.first_name} ${member.last_name}`}
      </Stack>
      <Box>{`${appointment}`}</Box>
      <Box>{`${member.fitlinxx_id}`}</Box>
      <Box>{`${GENERIC_MEMBER_STATUS_OPTIONS.find((f) => f.value === member.status).label}`}</Box>
      {true && (
        <Stack direction={"row"} gap={7}>
          {isSSSubscale && (
            <Stack direction={"row"} gap={"2px"}>
              SS
              <Tooltip content={"Social Support"} direction="bottom">
                <IconAttentionOrange />
              </Tooltip>
            </Stack>
          )}
          {isATDSubscale && (
            <Stack direction={"row"} gap={"2px"}>
              ATD
              <Tooltip content={"Ability to Tolerate Discomfort"} direction="bottom">
                <IconAttentionOrange />
              </Tooltip>
            </Stack>
          )}
          {isSMSubscale && (
            <Stack direction={"row"} gap={"2px"}>
              SM
              <Tooltip content={"Self Management"} direction="left">
                <IconAttentionOrange />
              </Tooltip>
            </Stack>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default TCAUserSummary;
